var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18.8002C14.8601 18.8002 18.8 14.8603 18.8 10.0002C18.8 5.14009 14.8601 1.2002 10 1.2002C5.13989 1.2002 1.2 5.14009 1.2 10.0002C1.2 14.8603 5.13989 18.8002 10 18.8002ZM9.05143 9.78286C8.81486 9.99886 8.69657 10.3743 8.69657 10.9091V12.7143H10.1623V11.2949C10.1623 11.0994 10.2034 10.9606 10.2857 10.8783C10.368 10.796 10.5069 10.7549 10.7023 10.7549C11.1549 10.7549 11.592 10.6417 12.0137 10.4154C12.4354 10.1789 12.78 9.84457 13.0474 9.41257C13.3149 8.98057 13.4486 8.48171 13.4486 7.916C13.4486 7.32971 13.3251 6.82057 13.0783 6.38857C12.8314 5.94629 12.4817 5.60686 12.0291 5.37029C11.5869 5.12343 11.0726 5 10.4863 5H7.2V6.38857H10.2549C10.7897 6.38857 11.2011 6.52743 11.4891 6.80514C11.7874 7.07257 11.9366 7.44286 11.9366 7.916C11.9366 8.37886 11.7977 8.74914 11.52 9.02686C11.2423 9.30457 10.872 9.44343 10.4091 9.44343H10.2394C9.69429 9.44343 9.29829 9.55657 9.05143 9.78286ZM8.61943 14.1029V15.8H10.2394V14.1029H8.61943Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9a567a57d7ba352b757758d572699e31.svg";
export { ForwardRef as ReactComponent };